import React from 'react';
import { buildImageURL, getTrack } from '../../helpers';

const track3 = getTrack({ block: 29 });

const IMAGES = {
  screen: {
    d: buildImageURL('/vp-broken-img1-x2.png'),
    m: buildImageURL('/vp-broken-img1-x2.png')
  }
};

export default function Protection({ mobile = false }) {
  const screenImg = mobile ? IMAGES.screen.m : IMAGES.screen.d;
  return (
    <div className="page-section stage-showcase section-buy-now" data-track={track3}>
      <div className="stage-sc-title">
        <h2>碎屏宝</h2>
        <div className="buy-more-link">
          <a
            className="line-link"
            href="https://shop.vivo.com.cn/product/brokenScreen"
            data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2209","name":"X60 Pro","series":"X系列","position":"1","pointsname":"碎屏宝"}}'
          >
            立即选购
          </a>
        </div>
      </div>
      <div className="stage-sc-figure">
        <div className="figure SC-protection-a lazyBackground" style={{ backgroundImage: `url(${screenImg})` }}>
          <a
            href="https://shop.vivo.com.cn/product/brokenScreen"
            data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2209","name":"X60 Pro","series":"X系列","position":"1","pointsname":"碎屏宝"}}'
          />
        </div>
      </div>
    </div>
  );
}
